import RoutesMap from "route_control/RouteControl"
import PageNotFound from './PageNotFound'
import {
    UserLogin,
    RoleSelection
} from "pages/user"

const AuthRoute = () => {
    return [
        {
            path: RoutesMap.LOGIN.path,
            element: <UserLogin />
        },
        {
            path: RoutesMap.ROLE_LOGIN.path,
            element: <RoleSelection />
        },
        {
            path: RoutesMap.UNKNOWN_PATH.path,
            element: <PageNotFound />
        },
    ]
}

export default AuthRoute;